import React from 'react';
import './Navbar.css';
import { Image } from 'react-bootstrap';
import { createUseStyles } from 'react-jss';

const styles = createUseStyles( theme => ({
  colorPrimary : {
      color: theme.colorPrimary
  }
}) );

export const Navbar = ({initData,state,setState}) => {
  const { usuario,nombre_completo } = initData;
  const classes = styles();
  const { openMenu } = {...state};
  return (
    <nav className="ws-top-navbar">
      <div className="container-fluid">
        <div className="d-flex justify-content-between align-items-center">
          <div className="logo-container">
            <img className="ws-logo" src="https://segurocotizas.com/docs/R710viHsA2-jwTlME6s11-WyKiq4yx5O-MVIUycj.png?id=62d815b8acc70" alt="logo-app" />
          </div>
          <div>
            <ul className="navbar-nav ms-auto">
              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  { nombre_completo }
                </a>
                <div className="dropdown-menu dropdown-menu-end animate slideIn" aria-labelledby="navbarDropdown">
                  <a className="dropdown-item" href="#"><i className="bi bi-tools pe-2"></i> Configuración</a>
                  <a className="dropdown-item" href="#"><i className="bi bi-power pe-2"></i> Salir</a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
}
